import {t} from '../../../common/getTranslations';
import {stopPropagationEvent} from '../../../common/shared/utils/stopPropagationEvent.function';
import {twMerge} from '../../../common/twMerge';
import {putTiaraObjectProps} from '../../../logging/putTiaraObjectProps';
import {Icon} from '../../atoms/Icon/Icon';
import {IconType} from '../../atoms/Icon/IconType.enum';
import {Text} from '../../atoms/Text/Text';
import {Label} from '../../molecules/Label/Label';
import {LabelType} from '../../molecules/Label/LabelType.enum';
import {ViewerEndPreviewCommentProps} from './ViewerEndPreviewCommentProps.interface';

export function ViewerEndPreviewComment({
  userName,
  comment,
  isHidden,
  onClickPreviewComment,
  onClickPreviewCommentOnOff,
  className,
  ...props
}: ViewerEndPreviewCommentProps) {
  return (
    <div
      className={twMerge([
        'relative flex h-80pxr cursor-pointer flex-col justify-center rounded-8pxr border-1 border-theme-transparent-20 px-12pxr py-9pxr',
        className,
      ])}
      onClick={e => {
        stopPropagationEvent(e);
        onClickPreviewComment(e);
      }}
      {...props}
    >
      {/* 미리보기 댓글 */}
      <div
        {...putTiaraObjectProps({
          click: {
            copy: isHidden ? 'on' : 'off',
          },
        })}
        className="absolute right-8pxr top-8pxr flex h-20pxr cursor-pointer items-center rounded-5pxr bg-theme-transparent-20 px-4pxr py-2pxr"
        onClick={e => {
          stopPropagationEvent(e);
          onClickPreviewCommentOnOff && onClickPreviewCommentOnOff(e);
        }}
      >
        <Icon
          type={
            isHidden
              ? IconType.ViewerEndCommentOff
              : IconType.ViewerEndCommentOn
          }
        />
      </div>
      {isHidden ? (
        <div className="flex h-full w-full items-center justify-center">
          <Text className="font-small1 text-theme-solid-100">
            {t('viewer_end_comment_hidden')}
          </Text>
        </div>
      ) : (
        <>
          <div className="flex items-center space-x-6pxr">
            <Label type={LabelType.Static06} text={t('comment_badge_best')} />
            <Text className="font-small1-bold text-theme-solid-100 line-clamp-1">
              {userName}
            </Text>
          </div>
          <div className="mt-8pxr">
            <Text className="font-small1 whitespace-pre-wrap text-theme-solid-100 line-clamp-2 break-word-anywhere">
              {comment}
            </Text>
          </div>
        </>
      )}
    </div>
  );
}
